import * as React from 'react';
import axios, { AxiosResponse } from "axios";

import Slider from "./Slider";
import Categories from "./Categories";
import { ICategory, IRubricProps, IRubricResponse } from "PyzShopUi/scripts/main-rubric-page/interfaces";
import { IProductItem } from "PyzShopUi/scripts/shop-ui/interfaces";
import { IStoreConfig } from "PyzShopUi/scripts/shop-ui/components/search-page/interfaces";
import { EAccordionEventHandler } from 'PyzShopUi/scripts/modules/events/accordion.event';
import { ListNameContext } from 'PyzShopUi/scripts/shop-ui/components/product-item/ProductItemListNameContext'

interface RubricState {
    rubricName: string
    items: IProductItem[]
    categories: ICategory[]
    storeConfig: IStoreConfig
}

const RUBRIC_LIST_NAME_PREFIX = 'Rubric-'

const Rubric: React.FunctionComponent<IRubricProps> = ({ apiUrl, skeletonName }) => {
    const [{categories, rubricName, items, storeConfig}, setState] = React.useState<RubricState>({
        categories: [],
        items: [],
        rubricName: '',
        storeConfig: null
    })

    React.useEffect(() => {
        axios.get(apiUrl.toString()).then((result: AxiosResponse<IRubricResponse>) => {
            setState((s) => ({
                ...s,
                rubricName: result.data.categoryName,
                items: result.data.catalog.resultItems.slice(0, 2) as IProductItem[],
                categories: result.data.childCategories ?? [],
                storeConfig: result.data.catalog.storeConfig
            }))
        });
    }, []);

    return (
        <div className="cell list-accordion" data-slidetoggle="true">
            <div className="accordion-header" data-toggleelement="header" data-event-handler={EAccordionEventHandler.LAZY_LOAD}>
                <div className="heading3">
                    {rubricName}
                    <i className="accordion-icon" data-toggleelement="icon"></i>
                </div>
            </div>

            <div className="accordion-content" data-toggleelement="content">
                <ListNameContext.Provider value={`${RUBRIC_LIST_NAME_PREFIX}${rubricName}`}>
                    <Slider items={items} skeletonName={skeletonName} storeConfig={storeConfig} />
                </ListNameContext.Provider>
                <Categories categories={categories} />
            </div>
        </div>
    );
};

export default Rubric;
